/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology,
* Texas A&M Engineering Experiment Station, The Texas A&M
* University System.
*
* This source code/schema and any derivative work is Texas
* A&M Engineering Experiment Station intellectual property
* and protected by copyright law. Usage is restricted solely
* to the FARM Animal Care and Environmental Stewardship
* programs administered by the National Milk Producers
* Federation. Dissemination of this source code and/or
* derivative work creation is strictly prohibited without
* express written permission from the Texas A&M Engineering
* Experiment Station.
*/
import { Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, List, ListItem, ListItemIcon, ListItemText, Paper, TextField, Theme, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import BugReport from "@material-ui/icons/BugReport";
import Feedback from "@material-ui/icons/Feedback";
import Info from "@material-ui/icons/Info";
import { createStyles, makeStyles } from "@material-ui/styles";
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { sendDiagnosticDataActions } from "../../redux";
import { helpUrl } from "../../config";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      padding: theme.spacing(4),
      overflowY: "scroll",
    },
    pane: {},
    title: {},
    section: {
      marginBottom: theme.spacing(10),
    },
    button: {
      textTransform: "none",
    },
    version: {},
    dialog: {},
  })
);

const HelpPage: FC<{}> = props => {

  const classes = useStyles(props);

  const dispatch = useDispatch();

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const [explanation, setExplanation] = useState<string | null>(null);
  const confirmSendDiagnostics = () => {
    setDialogOpen(true);
  };

  const handleSendDiagnostics = () => {
    dispatch(sendDiagnosticDataActions.request(explanation!));
    setDialogOpen(false);
  };

  const theme: Theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className={classes.root}>
      <Container maxWidth="md">
        {/*
          TODO: Add device info?
        <section className={classes.section}>
          <Paper className={classes.pane}>
            <List>
              <ListItem>
                <ListItemText
                  primary="App Version"
                  secondary={appVersion}
                  />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="OS"
                  secondary={appVersion}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="OS Version"
                  secondary={appVersion}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="App Version"
                  secondary={appVersion}
                />
              </ListItem>
            </List>
          </Paper>
        </section>
              */}

        <section className={classes.section}>
          <Typography variant="h6" className={classes.title}>
            Technical Assistance
          </Typography>
          <Paper className={classes.pane}>
            <List>
              <ListItem button component="a" href={helpUrl}>
                <ListItemText
                  primary="Resources"
                  secondary="Click here to visit Help Desk Central for resources related to FARM applications"
                />
                <ListItemIcon>
                  <Info />
                </ListItemIcon>
              </ListItem>
              <Divider />
              <ListItem button component="a" href="mailto:farmtechsupport@nmpf.org">
                <ListItemText
                  primary="Contact Help Desk"
                  secondary="If you are having difficulty with the app click here to email the Help Desk"
                />
                <ListItemIcon>
                  <Feedback />
                </ListItemIcon>
              </ListItem>
              <Divider />
              <ListItem button onClick={confirmSendDiagnostics}>
                <ListItemText
                  primary="Send Diagnostic Data"
                  secondary="Help us diagnose specific issues by sharing data from your app"
                />
                <ListItemIcon>
                  <BugReport />
                </ListItemIcon>
              </ListItem>
            </List>
          </Paper>
        </section>

        <section className={classes.section}>
          <Typography variant="h6" className={classes.title}>
            FARM Program Assistance
          </Typography>
          <Paper className={classes.pane}>
            <List>
              <ListItem button component="a" href="mailto:dairyfarm@nmpf.org">
                <ListItemText
                  primary="Contact FARM Team"
                  secondary="If you have questions regarding FARM standards or procedures, click here to email the FARM Team"
                />
                <ListItemIcon>
                  <Feedback />
                </ListItemIcon>
              </ListItem>
            </List>
            <Divider />
          </Paper>
        </section>
      </Container>

      <Dialog open={dialogOpen} fullWidth={true} className={classes.dialog} fullScreen={fullScreen}>
        <DialogTitle>Send Diagnostics</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Please provide an explanation of the issue that you are experiencing and the specific steps you performed. It would be helpful if you could provide the type of device and operating system version you are using as well as the version of the form and evaluation application. When you have finished entering your description click 'Send' which will send the file to the helpdesk.
          </DialogContentText>
          {/* {progress && <LinearProgress variant="determinate" value={progress} />} */}

          <TextField
            autoFocus
            variant="outlined"
            fullWidth
            id="diagnose-steps"
            placeholder="Problem explanation (optional)"
            rows={4}
            multiline
            onChange={event =>
              setExplanation(event.target.value && event.target.value.length > 0 ? event.target.value : null)
            }
          />
        </DialogContent>
        <DialogActions>
          <Button className={classes.button} onClick={() => setDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            className={classes.button}
            onClick={handleSendDiagnostics}
            // disabled={explanation === null}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HelpPage;
